<template>
  <div class="container mt-4">
    <div class="component-header">
      <h1 class="mb-2 font">Bibliografia</h1>
      <div class="ml-4 add-edit-actions">
        <button @click="add" class="action">
          <i class="fa fa-plus-square-o" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text ml-3"
        v-bind:class="[showMessage ? 'visible' : 'hidden', success ? 'text-success' : 'text-danger']"
      >
        {{ messageText }}
      </div>
    </div>
    <div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Lp</th>
            <th scope="col">Bibliografia</th>
            <th scope="col">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in bibliography" :key="item.id">
            <th scope="row">{{index+1 }}</th>
            <td v-html="item.content"></td>

            <td class>
              <div class="actions">
                <button @click="edit(item.id)" class="action">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
                <button
                  class="action"
                  @click="itemIdToRemove = item.id"
                  data-target="#bibliography"
                  data-toggle="modal"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal :settings="modalSettings" @confirm="remove()" />
  </div>
</template>

<script>
import Modal from "./Modal.vue";
export default {
  components: { Modal },
  comments: {
    Modal,
  },
  data() {
    return {
      separator: ", ",
      bibliography: [],
      modalSettings: {
        modalId: "bibliography",
      },
      modalShown: false,
      itemIdToRemove: "",
      messageText: "",
      showMessage: false,
    };
  },
  methods: {
    add: function () {
      this.$router.push({ name: "BibliographyAdd" });
    },
    edit: function (id) {
      this.$router.push({ name: "BibliographyEdit", params: { id } });
    },
    remove: function () {
      this.$api.deleteBibliography(this.itemIdToRemove).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.$api
            .getBibliography()
            .then((data) => (this.bibliography = data));
        } else {
          this.displayFailure();
        }
      });
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie usunięte";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w usuwaniu danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
  },
  created() {
    this.$api.getBibliography().then((data) => (this.bibliography = data));
  },
};
</script>

<style>
.actions {
  display: flex;
  /* justify-content: space-between; */
}
</style>